export const dataLayerName = 'dhlDataLayer'
